// extracted by mini-css-extract-plugin
module.exports = {"bottomPromo":"Promo_bottomPromo__2AlWu","btn":"Promo_btn__1Kvc9"};